import SearchSuggestionComponent from "./SearchSuggestionComponent";

export default SearchSuggestionComponent;